import { infoSlider } from "../modules/Sliders";

let swiperItems = $("[data-swiper]");
swiperItems.first().on("click", function() {
  infoSlider.slidePrev();
});
swiperItems.last().on("click", function() {
  infoSlider.slideNext();
});



// WEBPACK FOOTER //
// ./scripts/components/tournament-slider.js